module.exports = __webpack_public_path__ + "img/injineer_icon.9f63474f.svg";